var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Cards",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Cards",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3h1a2 2 0 012 2v6a2 2 0 01-2 2h-1a2 2 0 01-2 2H5a2 2 0 01-2-2H2a2 2 0 01-2-2V5a2 2 0 012-2h1a2 2 0 012-2h6a2 2 0 012 2zM2 5v6h1V5H2zm3-2v10h6V3H5zm9 2h-1v6h1V5zM9 5H7a1 1 0 000 2h2a1 1 0 000-2zm0 3H7a1 1 0 000 2h2a1 1 0 000-2z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgCarouselIcon;